import { MenuItem, Select } from "@mui/material";
import React from "react";

const ItemQuantity = ({ quantities, quantity, handleQuantity }) => {
	return (
		<Select
			labelId="demo-simple-select-label"
			id="demo-simple-select"
			value={quantities[quantity] || 0}
			displayEmpty
			inputProps={{ "aria-label": "Without label" }}
			onChange={handleQuantity}
			MenuProps={{
				style: { maxHeight: "300px" },
			}}
		>
			{quantities.map((quantity) => {
				return (
					<MenuItem key={quantity} value={quantity}>
						{quantity}
					</MenuItem>
				);
			})}
		</Select>
	);
};

export default ItemQuantity;
